import React, { useState } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Meta } from "react-head";

function LiveClass({
  courseId: initialCourseId,
  batchId: initialBatchId,
  teacherId:initialTeacherId,
  meetCode = "hqs-dxmc-iew",
}) {
  const [params, setParams] = useState({
    courseId: initialCourseId,
    batchId: initialBatchId,
    teacherId:initialTeacherId,
  });

  const meetUrl = `https://meet.google.com/${meetCode}`;

  const handleChangeParams = () => {
    setParams(() => ({
      courseId:Math.floor(1000 + Math.random() * 9000),
      batchId: Math.floor(1000 + Math.random() * 9000),
      teacherId:Math.floor(1000+ Math.random() * 9000),
    }));
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="custom-tooltip text-start" {...props}>
      Make sure to login with your <strong>Hunarho email</strong> on Google Meet to get host permissions.
    </Tooltip>
  );

  return (
    <>
      <Meta name="screenity-params" content={JSON.stringify(params)} />

      <main className="flex flex-col items-center gap-6 p-8 mb-3">
        <h1 className="text-2xl font-semibold">Live Session&nbsp;#{params.courseId}</h1>
        <div className="flex items-align-center">

          <button
            onClick={handleChangeParams}
            style={{ marginRight: 10 }}
            className="btn btn-primary rounded-lg bg-green-600 px-4 py-2 text-white shadow hover:bg-green-700 transition"
          >
            Update Meta Params (testing)
          </button>

          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 300 }}
            overlay={renderTooltip}
          >
            <a
              href={meetUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-lg btn btn-primary bg-blue-600 px-4 py-2 text-white font-medium shadow hover:bg-blue-700 transition"
            >
              Go Live
            </a>
          </OverlayTrigger>

        
        </div>
      </main>
    </>
  );
}

export default LiveClass;
